import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AdminLayout } from "../shared/layout";
import { getGptPrompt, updateGptPrompt } from "../../../data";

import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { CardBox } from "../shared/CardBox";

export function GptPromptUpdateScreen() {
  const queryClient = useQueryClient();
  const { id } = useParams();
  const navigate = useNavigate();

  const pageSettings = {
    title: "GPT Prompt Detayı",
    actions: [
      {
        name: "Listeye Dön",
        color: "blue",
        icon: "add-icon",
        onClick: () => {
          navigate("/admin/gptprompts");
        },
      },
    ],
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { data, isLoading, error } = useQuery({
    queryKey: ["gptPrompt", id],
    queryFn: async () => await getGptPrompt(id),
    retry: 0,
  });

  const mutation = useMutation({
    mutationKey: ["updateGptPrompt", id],
    mutationFn: (formData) => {
      return updateGptPrompt(id, formData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["gptPrompt", id] });
      alert("GPT Prompt başarıyla güncellendi!");
    },
    onError: (error) => {
      alert("Güncelleme hatası: " + error.message);
    },
  });

  const onSubmit = async (formData) => {
    mutation.mutate({
      name: formData.name,
      systemPrompt: formData.systemPrompt,
      userPrompt: formData.userPrompt,
      assistantPrompt: formData.assistantPrompt,
      isDefault: formData.isDefault === "true" || formData.isDefault === true,
      isForAgency: formData.isForAgency === "true" || formData.isForAgency === true,
    });
  };

  if (error) {
    return (
      <AdminLayout>
        <div className="text-red-500">Error: {error.message}</div>
      </AdminLayout>
    );
  }

  if (isLoading) {
    return (
      <AdminLayout>
        <div>Yükleniyor...</div>
      </AdminLayout>
    );
  }

  const promptData = data?.data;

  return (
    <AdminLayout
      title={pageSettings.title + " - " + (promptData?.name || id)}
      actions={pageSettings.actions}
    >
      <CardBox>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Name */}
          <div className="mb-6">
            <label
              className="block text-foreground text-sm font-bold mb-2"
              htmlFor="name"
            >
              Ad
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-foreground bg-background leading-tight focus:outline-none focus:shadow-outline"
              id="name"
              type="text"
              placeholder="Prompt adı"
              {...register("name", { required: "Ad zorunludur" })}
              defaultValue={promptData?.name}
            />
            {errors.name && (
              <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
            )}
          </div>

          {/* System Prompt */}
          <div className="mb-6">
            <label
              className="block text-foreground text-sm font-bold mb-2"
              htmlFor="systemPrompt"
            >
              Sistem Prompt'u
            </label>
            <textarea
              className="shadow appearance-none border rounded w-full py-2 px-3 text-foreground bg-background leading-tight focus:outline-none focus:shadow-outline"
              id="systemPrompt"
              rows={4}
              placeholder="Sistem prompt'u..."
              {...register("systemPrompt")}
              defaultValue={promptData?.systemPrompt}
            />
          </div>

          {/* User Prompt */}
          <div className="mb-6">
            <label
              className="block text-foreground text-sm font-bold mb-2"
              htmlFor="userPrompt"
            >
              Kullanıcı Prompt'u
            </label>
            <textarea
              className="shadow appearance-none border rounded w-full py-2 px-3 text-foreground bg-background leading-tight focus:outline-none focus:shadow-outline"
              id="userPrompt"
              rows={4}
              placeholder="Kullanıcı prompt'u..."
              {...register("userPrompt")}
              defaultValue={promptData?.userPrompt}
            />
          </div>

          {/* Assistant Prompt */}
          <div className="mb-6">
            <label
              className="block text-foreground text-sm font-bold mb-2"
              htmlFor="assistantPrompt"
            >
              Asistan Prompt'u
            </label>
            <textarea
              className="shadow appearance-none border rounded w-full py-2 px-3 text-foreground bg-background leading-tight focus:outline-none focus:shadow-outline"
              id="assistantPrompt"
              rows={4}
              placeholder="Asistan prompt'u..."
              {...register("assistantPrompt")}
              defaultValue={promptData?.assistantPrompt}
            />
          </div>

          {/* isDefault Checkbox */}
          <div className="mb-6">
            <label className="flex items-center">
              <input
                type="checkbox"
                className="form-checkbox h-5 w-5 text-blue-600"
                {...register("isDefault")}
                defaultChecked={promptData?.isDefault}
              />
              <span className="ml-2 text-foreground">Varsayılan</span>
            </label>
          </div>

          {/* isForAgency Checkbox */}
          <div className="mb-6">
            <label className="flex items-center">
              <input
                type="checkbox"
                className="form-checkbox h-5 w-5 text-blue-600"
                {...register("isForAgency")}
                defaultChecked={promptData?.isForAgency}
              />
              <span className="ml-2 text-foreground">Ajans için</span>
            </label>
          </div>

          <div className="flex items-center justify-between">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="submit"
              disabled={mutation.isPending}
            >
              {mutation.isPending ? "Güncelleniyor..." : "Güncelle"}
            </button>
          </div>
        </form>
      </CardBox>
    </AdminLayout>
  );
}
